// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import meetingStatusEntity from './entities/meeting-status.json';
import meetingStatusMenu from '../pages/meeting-status/menu.json';
import meetingStatusFullForm from '../pages/meeting-status/forms/full.json';
import meetingStatusContextForm from '../pages/meeting-status/forms/context.json';
import meetingStatusMiniForm from '../pages/meeting-status/forms/mini.json';
import meetingStatusLookupForm from '../pages/meeting-status/forms/lookup.json';
import meetingStatusTableView from '../pages/meeting-status/views/table.json';
import meetingStatusDashboardView from '../pages/meeting-status/views/dashboard.json';

/** Тип запису «Статус засідання» зі сторінками пакета: меню, форми та подання з pages/meeting-status/. */
export const meetingStatusDefinition: IRecordTypeDefinition = {
  ...meetingStatusEntity,
  views: assembleViewSet({
      table: meetingStatusTableView,
      dashboard: meetingStatusDashboardView,
  }),
  form: meetingStatusFullForm,
  forms: { full: meetingStatusFullForm, context: meetingStatusContextForm, mini: meetingStatusMiniForm, lookup: meetingStatusLookupForm },
  menu: meetingStatusMenu,
} as IRecordTypeDefinition;
